import TileDirection from './TileDirection';
import TileHolderFactory from './TileHolderFactory';

class TileCoordinator {

    constructor(specs) {

        this.specs = specs;

        this.center = {
            x: this.specs.board.width / 2,
            y: this.specs.board.height / 2
        };

        this.tileFactory = new TileHolderFactory(this.specs.tile.width, this.specs.tile.height);
    }

    placeTiles(plays) {

        if (!plays || plays.length === 0) {
            return {};
        }

        let holders = [];

        // 'root' tile with starting degrees
        let rootHolder = this.tileFactory.get(plays[0]);
        rootHolder.x = this.center.x;
        rootHolder.y = this.center.y;
        rootHolder.d = rootHolder.isSameSuit() ? 0 : 270;

        // Define the val of the tile on both ends. The way the
        //  code works, forces the greater suit to be on tile.b
        //  (which is set to point right if the first tile on the board)

        this.right = {
            holder: rootHolder,
            deg: 90,
            dir: TileDirection.RIGHT(),
            val: rootHolder.tile.b
        };

        this.left = {
            holder: rootHolder,
            deg: 270,
            dir: TileDirection.LEFT(),
            val: rootHolder.tile.a
        };

        holders.push(rootHolder);

        // Build on the rest of the plays/tiles
        for (let i = 1; i < plays.length; i++) {
            let nextTile = plays[i];
            let isRight = nextTile.action === 1;
            let end = isRight ? this.right : this.left;
            let newHolder = this.placeTile(end, nextTile);
            holders.push(newHolder);
        }

        return {
            placeholders: holders,
            left: this.left,
            right: this.right
        };
    }

    placeTile(end, nextTile) {

        let next = this.tileFactory.get(nextTile);
        let prev = end.holder;
        let deg = end.deg;
        let dir = end.dir;

        let pastLeftEdge = dir.label === TileDirection.LEFT().label
            && prev.x <= this.specs.board.spacing.horizontal;
        let pastTopEdge = dir.label === TileDirection.UP().label
            && prev.y <= this.specs.board.spacing.vertical;
        let pastRightEdge = dir.label === TileDirection.RIGHT().label
            && prev.x >= this.specs.board.width - this.specs.board.spacing.horizontal;
        let pastBottomEdge = dir.label === TileDirection.DOWN().label
            && prev.y >= this.specs.board.height - this.specs.board.spacing.vertical;

        let changeDir = !next.isSameSuit() && (pastLeftEdge || pastTopEdge || pastRightEdge || pastBottomEdge);

        //make the change in direction ONLY if not same suit to avoid orientation issues on edges
        if (changeDir) {
            dir = TileDirection.ROTATE(dir);
            deg += 90;
        }

        next.d = deg;

        //one-time override for special cases
        if (next.isSameSuit()) {
            next.d += 90;
        }
        
        // May need a 180-degree flip for matching ends of the tiles
        if (this.shouldFlip(end, prev, next)) {
            next.d += 180;
        }

        let anchor = prev.getAnchorPoint(dir);
        let newCenter = next.getOffsetPoint(anchor.x, anchor.y, dir);

        //changing direction and should be aligned to the outward edge of the 
        // previous tile IF not a double
        //in order to do that, it has to be rotated 90 degrees THREE times
        if (changeDir && !prev.isSameSuit()) {

            var offsetDir = TileDirection.ROTATE(dir);
            offsetDir = TileDirection.ROTATE(offsetDir);
            offsetDir = TileDirection.ROTATE(offsetDir);

            newCenter = next.getOffsetPoint(newCenter.x, newCenter.y, offsetDir);
        }

        next.x = newCenter.x;
        next.y = newCenter.y;

        // New val default to a
        let newVal = next.tile.a;
        // Check if val is b instead
        if (next.tile.a === end.val) {
            newVal = next.tile.b;
        }

        // Update end
        end.holder = next;
        end.deg = deg;
        end.dir = dir;
        end.val = newVal;

        return next;
    }

    shouldFlip(end, prev, next) {

        return end.val === next.tile.a;
    }
}

export default TileCoordinator;


// WEBPACK FOOTER //
// ./src/TileCoordinator.jsx